import Marquee from "react-fast-marquee";

export default function HypeSection() {
  const line =
    "$LA28 IS A COMMUNITY MOVEMENT POWERED BY INTERNET CULTURE AND COUNTDOWN ENERGY";
  return (
    <section
      data-testid="hype-section"
      className="relative py-28 sm:py-40 border-y border-white/10 overflow-hidden bg-[#05050A]"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url("https://images.unsplash.com/photo-1768527858342-037cff722276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxuZW9uJTIwZ3JpZCUyMGFic3RyYWN0JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODEzOTM1MDZ8MA&ixlib=rb-4.1.0&q=85")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#05050A]/85 via-[#05050A]/70 to-[#05050A]/95" />

      <div className="relative space-y-6">
        <Marquee speed={45} gradient={false}>
          <div className="flex items-center gap-12 pr-12">
            <span className="font-heading text-6xl sm:text-8xl lg:text-9xl font-black tracking-tighter text-white whitespace-nowrap glow-text">
              {line}
            </span>
            <span className="text-[#00F0FF] text-6xl sm:text-8xl lg:text-9xl">
              ✦
            </span>
          </div>
        </Marquee>

        <Marquee speed={45} gradient={false} direction="right">
          <div className="flex items-center gap-12 pr-12">
            <span className="font-heading text-6xl sm:text-8xl lg:text-9xl font-black tracking-tighter text-white/30 whitespace-nowrap">
              {line}
            </span>
            <span className="text-[#FFD700] text-6xl sm:text-8xl lg:text-9xl">
              ✦
            </span>
          </div>
        </Marquee>

        <Marquee speed={45} gradient={false}>
          <div className="flex items-center gap-12 pr-12">
            <span className="font-heading text-6xl sm:text-8xl lg:text-9xl font-black tracking-tighter text-white whitespace-nowrap">
              {line}
            </span>
            <span className="text-[#00F0FF] text-6xl sm:text-8xl lg:text-9xl">
              ✦
            </span>
          </div>
        </Marquee>
      </div>

      <div className="relative max-w-3xl mx-auto px-6 mt-16 text-center">
        <p
          data-testid="hype-tagline"
          className="font-mono text-xs sm:text-sm tracking-[0.32em] text-[#00F0FF]"
        >
          // NO TEAM · NO PROMISES · ONLY MOMENTUM
        </p>
      </div>
    </section>
  );
}
